import * as React from 'react'

import type { IconProps } from '@/icons/types'
export const MagnifyingGlassMini = React.forwardRef<SVGSVGElement, IconProps>(
	({ color = 'currentColor', ...props }, ref) => {
		return (
			<svg xmlns='http://www.w3.org/2000/svg' width={15} height={15} fill='none' ref={ref} {...props}>
				<path
					stroke={color}
					strokeLinecap='round'
					strokeLinejoin='round'
					strokeWidth={1.5}
					d='M13.056 13.056 9.53 9.53M6.389 10.833a4.444 4.444 0 1 0 0-8.888 4.444 4.444 0 0 0 0 8.888'
				/>
			</svg>
		)
	}
)
MagnifyingGlassMini.displayName = 'MagnifyingGlassMini'
